var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.5552,
    y1: 38.3456,
    x2: 508.3253,
    y2: 95.1156,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M483.74,457.604l-26.136,26.136c-5.391,5.391-14.132,5.391-19.523,0l0,0l45.659-45.659l0,0 C489.131,443.472,489.131,452.213,483.74,457.604z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.851,
    y1: 109.2099,
    x2: 463.711,
    y2: 212.0699,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M332.903,276.618L332.903,276.618l-56.285,56.285l0,0 c12.167,12.168,22.091,26.386,29.316,42.002l0.92,1.988c7.225,15.616,17.149,29.836,29.317,42.002l56.743,56.743 c16.758,16.758,43.931,16.758,60.689,0l22.036-22.036c16.758-16.758,16.758-43.931,0-60.689l-56.743-56.743 c-12.167-12.167-26.386-22.091-42.002-29.316l-1.989-0.92C359.289,298.71,345.07,288.786,332.903,276.618z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.827,
    y1: 148.0839,
    x2: 404.857,
    y2: 129.1139,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M381.849,332.267L381.849,332.267c4.213-4.213,11.043-4.213,15.257,0l64.205,64.205 c4.213,4.213,4.213,11.043,0,15.257l0,0c-4.213,4.213-11.043,4.213-15.257,0l-64.205-64.205 C377.637,343.31,377.637,336.479,381.849,332.267z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.9425,
    y1: 130.5784,
    x2: 372.9725,
    y2: 111.6084,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M330.351,330.351L330.351,330.351c4.213-4.213,11.043-4.213,15.257,0L448.79,433.534 c4.213,4.213,4.213,11.043,0,15.257l0,0c-4.213,4.213-11.043,4.213-15.257,0L330.351,345.608 C326.138,341.395,326.138,334.565,330.351,330.351z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.437,
    y1: 98.6939,
    x2: 355.467,
    y2: 79.7239,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M332.266,381.85L332.266,381.85c4.213-4.213,11.043-4.213,15.257,0l64.205,64.205 c4.213,4.213,4.213,11.043,0,15.257l0,0c-4.213,4.213-11.043,4.213-15.257,0l-64.205-64.205 C328.053,392.894,328.053,386.063,332.266,381.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.5189,
    y1: 180.875,
    x2: 255.6189,
    y2: 225.755,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M374.905,305.935c-15.616-7.225-29.836-17.149-42.002-29.315l0,0l-56.285,56.285 c4.802,4.802,9.247,9.927,13.322,15.327h141.015l-12.059-12.059c-12.168-12.168-26.386-22.091-42.002-29.317L374.905,305.935z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.2275,
    y1: 298.5533,
    x2: 232.5675,
    y2: 339.8934,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    points: "334.638,296.55 296.55,334.639 74.367,112.456 112.456,74.367 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2,
    y1: 424.9409,
    x2: 112.75,
    y2: 482.4909,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M123.327,88.263l-35.064,35.064c-5.426,5.426-14.387,4.836-19.055-1.255L25.729,65.344 c-2.865-3.739-2.518-9.021,0.813-12.352l26.449-26.449c3.331-3.331,8.614-3.678,12.352-0.813l56.73,43.478 C128.163,73.875,128.752,82.837,123.327,88.263z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.189,
    y1: 216.2457,
    x2: 350.059,
    y2: 195.8257,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M341.438,302.705l-38.733,38.733c-10.696,10.696-28.038,10.696-38.733,0l0,0 c-10.696-10.696-10.696-28.038,0-38.733l38.733-38.733c10.696-10.696,28.038-10.696,38.733,0l0,0 C352.134,274.668,352.134,292.01,341.438,302.705z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.088,
    y1: 207.2629,
    x2: 273.058,
    y2: 241.2929,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M341.438,302.705l-38.733,38.733c-10.696,10.696-28.038,10.696-38.733,0l0,0 c-10.696-10.696-10.696-28.038,0-38.733l38.733-38.733c10.696-10.696,28.038-10.696,38.733,0l0,0 C352.134,274.668,352.134,292.01,341.438,302.705z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.3456,
    y1: 296.0105,
    x2: 375.9256,
    y2: 140.4205,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    points: "181.466,398.449 113.55,330.533 332.543,111.54 400.46,179.456 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.6706,
    y1: 243.6855,
    x2: 198.7006,
    y2: 317.6455,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M318.041,193.959L318.041,193.959c8.916,8.916,8.916,23.371,0,32.287l-89.785,89.785 c-8.916,8.916-23.371,8.916-32.287,0l0,0c-8.916-8.916-8.916-23.371,0-32.287l89.785-89.785 C294.669,185.043,309.125,185.043,318.041,193.959z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.607,
    y1: 272.8528,
    x2: 355.607,
    y2: 411.0829,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#777777",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B4041"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    points: "313.928,130.155 313.928,265.987 400.46,179.456 332.543,111.54 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.8846,
    y1: 430.7473,
    x2: 1.1447,
    y2: 256.5074,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M502.062,77.657L449.919,129.8c-2.519,2.519-5.976,3.868-9.535,3.723l-47.734-1.962 c-6.628-0.272-11.939-5.583-12.211-12.211l-1.961-47.734c-0.147-3.559,1.204-7.016,3.723-9.535l52.149-52.149 c2.584-2.584,1.236-6.963-2.339-7.721c-32.668-6.932-68.102,2.443-93.276,28.137c-37.9,38.682-38.342,101.245-0.962,140.431 c39.309,41.206,104.591,41.788,144.633,1.747c25.146-25.146,34.265-60.246,27.368-92.617 C509.019,76.372,504.617,75.103,502.062,77.657z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.295,
    y1: 288.1218,
    x2: -56.445,
    y2: 7.8217,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M77.657,502.062l52.143-52.143c2.519-2.519,3.868-5.976,3.723-9.535l-1.962-47.734 c-0.272-6.628-5.583-11.939-12.211-12.211l-47.734-1.961c-3.559-0.147-7.016,1.204-9.535,3.723L9.931,434.349 c-2.584,2.584-6.963,1.236-7.721-2.339c-6.932-32.668,2.443-68.102,28.137-93.276c38.682-37.9,101.245-38.342,140.431-0.962 c41.206,39.309,41.788,104.591,1.747,144.633c-25.146,25.146-60.246,34.265-92.617,27.368 C76.372,509.019,75.103,504.617,77.657,502.062z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.c0bef8b195fda7e33d484d7b5ed4ce7e.svg";
export { ForwardRef as ReactComponent };